var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
import configEditorActions from "../actions/ConfigEditorActions.js";
import { createReducer } from "@ane/legacy/lib/decorators/ReduxDecorators";
const initialState = {
  config: "Loading...",
  configMap: {},
  error: "",
  isLoading: false,
  mode: "edit",
  parentConfig: "Loading...",
  schema: "",
  previewContent: {}
};
class ConfigEditorReducer {
  getConfig(state, action) {
    if (action.error === true) {
      return this.errorState(state, action);
    }
    const { json, section, path } = action.payload;
    return __spreadProps(__spreadValues({}, state), {
      configMap: __spreadProps(__spreadValues({}, state.configMap), {
        [`${section}${path || "/"}`]: json
      })
    });
  }
  editConfig(state, action) {
    if (action.error === true) {
      return this.errorState(state, action);
    }
    const { json, section, path } = action.payload;
    const config = JSON.stringify(json, null, 4);
    return __spreadProps(__spreadValues({}, state), {
      config,
      configMap: __spreadProps(__spreadValues({}, state.configMap), {
        [`${section}/${path}`]: json
      }),
      configObject: json
    });
  }
  clearConfig(state) {
    return __spreadProps(__spreadValues({}, state), {
      config: "Loading...",
      configObject: {}
    });
  }
  getSchema(state, action) {
    if (action.error === true) {
      return this.errorState(state, action);
    }
    return __spreadProps(__spreadValues({}, state), {
      schema: action.payload
    });
  }
  getDiffConfig(state, action) {
    if (action.error === true) {
      return this.errorState(state, action);
    }
    return __spreadProps(__spreadValues({}, state), {
      parentConfig: action.payload
    });
  }
  changeCode(state, action) {
    const configObject = this.tryParseConfig(action.payload, state.configObject);
    return __spreadProps(__spreadValues({}, state), {
      configObject,
      config: action.payload
    });
  }
  changeMode(state, action) {
    const configObject = this.tryParseConfig(action.payload, state.configObject);
    if (action.error === true) {
      return __spreadProps(__spreadValues({}, this.errorState(state, action)), { configObject });
    }
    return __spreadProps(__spreadValues({}, state), {
      mode: action.payload
    });
  }
  createConfig(state, action) {
    return state;
  }
  previewConfig(state, action) {
    return __spreadProps(__spreadValues({}, state), {
      preview: action.payload
    });
  }
  getPreviewContent(state, action) {
    const { targetPath, originalContent, section, content } = action.payload;
    return __spreadProps(__spreadValues({}, state), {
      previewContent: __spreadProps(__spreadValues({}, state.previewContent), {
        [action.payload.targetPath]: content
      }),
      configMap: __spreadProps(__spreadValues({}, state.configMap), {
        [`${section}${targetPath || "/"}`]: originalContent
      })
    });
  }
  clearPreviewContent(state) {
    return __spreadProps(__spreadValues({}, state), {
      preview: void 0,
      previewContent: {}
    });
  }
  setExperimentationGroup(state) {
    return __spreadValues({}, state);
  }
  errorState(state, action) {
    return __spreadProps(__spreadValues({}, state), {
      error: action.payload
    });
  }
  tryParseConfig(config, oldObject) {
    if (config) {
      try {
        return JSON.parse(config);
      } catch (e) {
        return oldObject;
      }
    }
    return config;
  }
}
const reducer = createReducer(configEditorActions, new ConfigEditorReducer(), initialState);
export {
  ConfigEditorReducer,
  reducer as default,
  initialState
};
//# sourceMappingURL=ConfigEditorReducer.js.map
